import React from 'react';

interface CircularProgressProps {
  days: number;
  progress: number;
}

export const CircularProgress: React.FC<CircularProgressProps> = ({ days, progress }) => {
  const radiusBg = 39;
  const radius = 40;
  const strokeWidthBg = 7;
  const strokeWidth = 5;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div className="flex items-center justify-center">
      <svg
        width="90"
        height="90"
        viewBox="0 0 90 90"
        className="transform scale-y-[-1] rotate-[-90deg]"
        style={{ transformOrigin: 'center' }}
      >
        <defs>
          <linearGradient id="progressGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#A366FF" />
            <stop offset="100%" stopColor="#7C73FF" />
          </linearGradient>
        </defs>
        <circle
          cx="45"
          cy="45"
          r={radiusBg}
          fill="none"
          stroke="var(--color-white-10)"
          strokeWidth={strokeWidthBg}
        />
        <circle
          cx="45"
          cy="45"
          r={radius}
          fill="none"
          stroke="url(#progressGradient)"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <span className="absolute flex flex-col items-center">
        <span className="text-white text-r12">{days}</span>
        <span className="text-regular text-r12">Days left</span>
      </span>
    </div>
  );
};
